import { FC, useEffect, useState } from 'react';
import { jobTrendRankingSelector } from '@doda/common/src/redux/features/JobContent/JobTrend/jobTrendRanking';
import { useAppSelector } from 'redux/hooks';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { jobTrendRecommendListSelector } from '@doda/common/src/redux/features/JobContent/JobTrend/jobTrendRecommendList';
import { jobRecommendOffsetSelector } from '@doda/common/src/redux/features/JobContent/JobTrend/jobRecommendOffset';
import { useBargraphSelected } from '@doda/common/src/hooks/JobContent/JobTrend/useBargraphSelected';
import {
  LABEL_FLAG,
  LABEL_NAME,
} from '@doda/common/src/constants/seo/jobTrendConstants';
import { JobCountBargraphAreaByCategory } from '../JobCountBargraphAreaByCategory';

/**
 * JobCountBargraphAreaのProps
 * @param targetName ページに訪れたパラメータの項目名
 */
export interface Props {
  targetName: string;
}

export const JobCountBargraphArea: FC<Props> = ({ targetName }) => {
  const rankingList = useAppSelector(jobTrendRankingSelector);
  const queryParams = useAppSelector(appQueryParamsSelector);
  const initJobList = useAppSelector(jobTrendRecommendListSelector);
  const jobRecommendOffset = useAppSelector(jobRecommendOffsetSelector);
  const bargraphSelected = useBargraphSelected();

  // BalloonNotice表示判定フラグの状態管理(-1:表示 1:非表示)
  const [isTrendPageVisited, setIsTrendPageVisited] = useState('1');

  // sessionStorageのkey
  const SESSION_STORAGE_KEY = 'isTrendPageVisited';

  useEffect(() => {
    const sessionStorageValue = sessionStorage.getItem(SESSION_STORAGE_KEY);
    if (sessionStorageValue) {
      setIsTrendPageVisited(sessionStorageValue);
    } else {
      setIsTrendPageVisited('-1');
    }
    // 画面上のどこかをクリックした時点でtrueをセットする
    document.body.onclick = () => {
      setIsTrendPageVisited('1');
    };
  }, []);

  useEffect(() => {
    sessionStorage.setItem(SESSION_STORAGE_KEY, isTrendPageVisited);
  }, [isTrendPageVisited]);

  return (
    <>
      <JobCountBargraphAreaByCategory
        targetName={targetName}
        categoryConstants={LABEL_NAME.REQUIREMENT}
        categoryFlg={LABEL_FLAG.REQUIREMENT}
        rankingList={rankingList.requirements}
        bargraphSelected={bargraphSelected}
        initJobList={initJobList}
        queryParams={queryParams}
        jobRecommendOffset={jobRecommendOffset}
        publicationDate={rankingList.publicationDate}
        isTrendPageVisited={isTrendPageVisited}
      />
      <JobCountBargraphAreaByCategory
        targetName={targetName}
        categoryConstants={LABEL_NAME.INCOME}
        categoryFlg={LABEL_FLAG.INCOME}
        rankingList={rankingList.income}
        bargraphSelected={bargraphSelected}
        initJobList={initJobList}
        queryParams={queryParams}
        jobRecommendOffset={jobRecommendOffset}
        publicationDate={rankingList.publicationDate}
        isTrendPageVisited={isTrendPageVisited}
      />
      <JobCountBargraphAreaByCategory
        targetName={targetName}
        categoryConstants={LABEL_NAME.WORKPLACE_ENVIRONMENT}
        categoryFlg={LABEL_FLAG.WORKPLACE_ENVIRONMENT}
        rankingList={rankingList.workplaceEnvironment}
        bargraphSelected={bargraphSelected}
        initJobList={initJobList}
        queryParams={queryParams}
        jobRecommendOffset={jobRecommendOffset}
        publicationDate={rankingList.publicationDate}
        isTrendPageVisited={isTrendPageVisited}
      />
      <JobCountBargraphAreaByCategory
        targetName={targetName}
        categoryConstants={LABEL_NAME.HOLIDAY_AND_WAY_OF_WORKING}
        categoryFlg={LABEL_FLAG.HOLIDAY_AND_WAY_OF_WORKING}
        rankingList={rankingList.holidayAndWayOfWorking}
        bargraphSelected={bargraphSelected}
        initJobList={initJobList}
        queryParams={queryParams}
        jobRecommendOffset={jobRecommendOffset}
        publicationDate={rankingList.publicationDate}
        isTrendPageVisited={isTrendPageVisited}
      />
      <JobCountBargraphAreaByCategory
        targetName={targetName}
        categoryConstants={LABEL_NAME.EMPLOYEE_AVERAGE_AGE}
        categoryFlg={LABEL_FLAG.EMPLOYEE_AVERAGE_AGE}
        rankingList={rankingList.employeeAverageAge}
        bargraphSelected={bargraphSelected}
        initJobList={initJobList}
        queryParams={queryParams}
        jobRecommendOffset={jobRecommendOffset}
        publicationDate={rankingList.publicationDate}
        isTrendPageVisited={isTrendPageVisited}
      />
      <JobCountBargraphAreaByCategory
        targetName={targetName}
        categoryConstants={LABEL_NAME.EMPLOYMMENT_STATUS}
        categoryFlg={LABEL_FLAG.EMPLOYMMENT_STATUS}
        rankingList={rankingList.employmentStatus}
        bargraphSelected={bargraphSelected}
        initJobList={initJobList}
        queryParams={queryParams}
        jobRecommendOffset={jobRecommendOffset}
        publicationDate={rankingList.publicationDate}
        isTrendPageVisited={isTrendPageVisited}
      />
      <JobCountBargraphAreaByCategory
        targetName={targetName}
        categoryConstants={LABEL_NAME.WELFARE_BENEFITS}
        categoryFlg={LABEL_FLAG.WELFARE_BENEFITS}
        rankingList={rankingList.welfareBenefits}
        bargraphSelected={bargraphSelected}
        initJobList={initJobList}
        queryParams={queryParams}
        jobRecommendOffset={jobRecommendOffset}
        publicationDate={rankingList.publicationDate}
        isTrendPageVisited={isTrendPageVisited}
      />
      <JobCountBargraphAreaByCategory
        targetName={targetName}
        categoryConstants={LABEL_NAME.LANGUAGE_AND_POSITIONS}
        categoryFlg={LABEL_FLAG.LANGUAGE_AND_POSITIONS}
        rankingList={rankingList.positionsAndLanguageSkills}
        bargraphSelected={bargraphSelected}
        initJobList={initJobList}
        queryParams={queryParams}
        jobRecommendOffset={jobRecommendOffset}
        publicationDate={rankingList.publicationDate}
        isTrendPageVisited={isTrendPageVisited}
      />
      <JobCountBargraphAreaByCategory
        targetName={targetName}
        categoryConstants={LABEL_NAME.ESTABLISH}
        categoryFlg={LABEL_FLAG.ESTABLISH}
        rankingList={rankingList.establish}
        bargraphSelected={bargraphSelected}
        initJobList={initJobList}
        queryParams={queryParams}
        jobRecommendOffset={jobRecommendOffset}
        publicationDate={rankingList.publicationDate}
        isTrendPageVisited={isTrendPageVisited}
      />
    </>
  );
};
